import React from "react";

import { WithdrawInvoicesWrapper } from "../../../components";

export default function WithdrawInvoicesPage() {
  return <WithdrawInvoicesWrapper />;
}
